import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router-dom';
// import LazyLoad from 'react-lazyload';
// import PropTypes from 'prop-types';

// Components
// import ErrorBoundary from 'components/_shared/ErrorBoundary/ErrorBoundary';

// Images
// import ExplanatoryLogo from "images/explanatory_logo.png"

// SVGs
import { ReactComponent as Pin } from 'svgs/pin.svg';
// Constants
import { organizationLogos, staticData } from 'constants/constants';
// Services
// Styles
import './Details.css';

// Redux Actions
import {
  setSearch,
  setFilter
} from 'store/modules/db/search/searchReducer';

const mapStateToProps = state => ({
  artworxProviders: state.db.providers.providers,
});

const sectors = [
  'organizational',
  'creative',
  'pipeline',
  'ages',
  'populations',
  'individuals',
  'affiliated',
  'community',
  'initiatives'
];

const similarSectors = [
  'organizational',
  'creative',
  'pipeline',
  'populations',
  'community'
];

export class Details extends React.Component {
  // Prop Types
  // ------------------------------------------------------------------------ //
  static propTypes = {};
  static defaultProps = {};

  // Constructor
  // ------------------------------------------------------------------------ //
  // constructor(props) {
  //   super(props);
  // }

  // Variables
  // ------------------------------------------------------------------------ //

  // Lifecycle methods
  // ------------------------------------------------------------------------ //
  componentDidMount() {
    this.getAllData();
  }

  // componentDidUpdate() {
  // }

  // componentWillUnmount() {
  // }

  // Event handlers
  // ------------------------------------------------------------------------ //
  directoryNav = e => {
    if (e) e.preventDefault()
    this.props.dispatch(push('/directory'))
  }

  filterAndGo = (e, filter, filterType) => {
    if (e) e.preventDefault()
    if (filterType === 'initiatives') return;
    this.props.dispatch(setFilter({
      type: filterType,
      query: filterType === 'pipeline' ? filter.toUpperCase() : filter
    }))
    this.directoryNav(null);
  }

  searchAndNav = (e, val) => {
    if (e) e.preventDefault()
    this.props.dispatch(setSearch({ search: val }));
    this.directoryNav(null)
  }

  // Class methods
  // ------------------------------------------------------------------------ //
  formatPart = part => {
    let lowPart = part.toLowerCase();
    return lowPart.charAt(0).toUpperCase() + lowPart.slice(1);
  }

  getAllData = async () => {
    if (!this.props.artworxProviders.length) {
      await this.props.getProviders()
    }
  }

  getRandomInt = max => {
    return Math.floor(Math.random() * Math.floor(max));
  }

  scrubString = str => {
    return str.replace(/[^\x00-\x7F]/g, "");
  }

  // Render methods
  // ------------------------------------------------------------------------ //
  renderSectors = (sectorList, provider) => {
    return sectorList.map(sector => {
      return (
        <li key={`${sector}_key`} className={`details__sector`}>
          <h6>{staticData.titles[sector]}</h6>
          <ul className={`details__sector-parts`}>
          {Array.isArray(provider[sector]) ?
            provider[sector].map((part, idx, arr) => {
            return (
              <li key={`${part}_${idx}`}
                className={`details__sector-part`}>
                <a href="#/"
                  onClick={e => this.filterAndGo(e, part, sector)}>
                  {this.formatPart(part)}{idx !== arr.length - 1 ? "," : ""}
                </a>
              </li>
            )
          }) :
            (
              <li className={`details__sector-part`}>
                <a href="#/"
                  onClick={e => this.filterAndGo(e, provider[sector], sector)}>
                  {this.formatPart(provider[sector])}</a>
              </li>
            )
          }
          </ul>
        </li>
      )
    })
  }

  render() {
    const { org } = this.props.match.params;
    const { artworxProviders } = this.props;
    if (!artworxProviders.length) {
      return <div className={`details details--requesting`}></div>
    }

    let provider = artworxProviders.find(entity => entity.organization === org)

    let similars = artworxProviders
      .filter(entity => {
        let similarSector = similarSectors[this.getRandomInt(similarSectors.length - 1)];
        let sector = provider[similarSector];
        let random = sector[this.getRandomInt(sector.length - 1)];
        return entity[similarSector].indexOf(random) > -1;
      })
      .slice(0,5);

    let orgLogo = organizationLogos.find(
      lgo => provider.organization.toLowerCase().trim().replace(/ /g, '_') === lgo.split('/')[3].split('.')[0]
    )

    return (
      <div className="details">
        <section className={`details__facie`}>
          <div className={`details__facie-info`}>
            <h1>{provider.organization}</h1>
            <ul className={`details__facie-locations`}>
              {provider.contact.length && provider.contact.map(
                location => {
                  return location.address || location.city ?
                    <li key={`${location.address}_key`}
                      className={`details__facie-location`}>
                      <a href="#/"
                        onClick={e => this.searchAndNav(e, provider.organization)}>
                        <Pin /></a><p>{location.address || ''} {location.city || ''}</p>
                    </li>
                    :
                    null
                }
              )}
            </ul>
            { provider.information && provider.information.map(
              ({site}) => (
                <a key={site} target="_blank" href={`${site}`} className={`details__facie-site`} rel="noopener noreferrer">{site}</a>
              )
            )}
          </div>
          <div className={`details__facie-org-image`}>
            {orgLogo && <img src={orgLogo} alt="detail logo"/>}
          </div>
        </section>

        <section className={`details__info`}>
          <div className={`details__info-overview`}>
            <h6>overview</h6>
            <p>{this.scrubString(provider.overview)}</p>
          </div>
          <div className={`details__info-contacts`}>
            <h6>contact</h6>
            <ul className={`details__info-telephones`}>
              {provider.contact.length && provider.contact.map(
                contact => {
                  return contact.telephone || contact.fax || contact.email ?
                    <li key={`${contact.telephone || contact.fax}_key`}
                      className={`details__info-phone`}>
                      {contact.telephone ? <p>Phone: { contact.telephone }</p> : null}
                      {contact.fax ? <p>Fax: { contact.fax }</p> : null}
                      {contact.email ? <p>{ contact.email }</p> : null}
                    </li>
                    :
                    null
                }
              )}
            </ul>
          </div>
        </section>

        <section className={`details__specifics`}>
          <ul className={`details__specifics-list`}>
            {this.renderSectors(sectors.slice(0, 5), provider)}
          </ul>
          <ul className={`details__specifics-list`}>
            {this.renderSectors(sectors.slice(5), provider)}
          </ul>
        </section>

        <section className={`details__similar`}>
          <div className={`details__similar-container`}>
            <div className="details__similar-headline">
              <h2>You may also be interested in connecting with these similar organizations</h2>
            </div>
            <div className={`details__similar-orgs`}>
              <ul className={`details__similar-list`}>
                {similars.map(similarOrg => {
                  return (
                    <li key={`${similarOrg.timestamp}_similar_key`}
                      className={`details__similar-organization`}>
                    {/*<a href="#/"
                        onClick={e => this.searchAndNav(e, similarOrg.organization)}>*/}
                    <Link to={`/details/${similarOrg.organization}`}>{similarOrg.organization}</Link></li>
                  )
                })}
              </ul>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Details);



// WEBPACK FOOTER //
// ./src/components/Details/Details.js